import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-edit-profile',
  templateUrl: './e-edit-profile.component.html',
  styleUrls: ['./e-edit-profile.component.css']
})
export class EEditProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
